<template>
    <div class="footer v2">
        <div class="copyright v2">{{ copyright }}</div>
    </div>
</template>

<script>
export default {
    name: 'v2-footer',
    props: {
        copyright: {
            type: String,
            default: '您所提交的内容应合法合规，且不得侵犯百度或第三人合法权益。您在本平台生成的内容仅限于百度推广平台内推广设置时使用。'
        }
    }
};
</script>

<style lang="less" scoped>
.footer {
    height: 40px;
    padding-top: 12px;
    width: 100%;
    .copyright {
        width: 100%;
        text-align: center;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        color: #3A4978;
    }
}
</style>